import Box from '@mui/system/Box';
import { ReactNode } from 'react';

interface BrandLogoWrapperProps {
  children: ReactNode;
}
const BrandLogoWrapper: React.FC<BrandLogoWrapperProps> = ({ children }) => (
  <Box
    className='brand-select-shell'
    display='flex'
    alignItems='center'
    mt='10px'
    zIndex='2'
    boxSizing='border-box'
    width='100%'
    minHeight='46px'
    sx={{
      borderColor: 'typography.main',
    }}
  >
    {children}
  </Box>
);

export default BrandLogoWrapper;
